import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "size", "total", "loaded", "frame" ]

  connect() {
    this.updateTotal()
    const queue = this.frameTargets.filter(frame => !frame.src || !frame.complete)
    this.queue = queue
    for (let i = 0; i < 4; i++) this.loadFrames(queue)
  }

  disconnect() {
    this.queue = null
  }

  async loadFrames(queue) {
    while (this.queue === queue && queue.length > 0) {
      const frame = queue.shift()
      if (!frame.src) frame.src = frame.dataset.src
      await frame.loaded
    }
  }

  sizeTargetConnected() {
    this.updateTotal()
  }

  sizeTargetDisconnected() {
    this.updateTotal()
  }

  updateTotal() {
    const total = this.sizeTargets.reduce((sum, element) => sum + Number(element.dataset.size), 0)
    this.totalTarget.textContent = (total / 1024 / 1024).toLocaleString("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
    this.loadedTarget.textContent = this.sizeTargets.length
  }
}
